export {
  IFontFace,
  IFontWeight,
  IRawStyle,
  IStyle,
  IStyleSet,
  IProcessedStyleSet,
  IStyleSheetConfig,
  ICSPSettings,
  InjectionMode,
  Stylesheet,
  concatStyleSets,
  fontFace,
  keyframes,
  mergeStyleSets,
  mergeStyles
} from '@uifabric/merge-styles';
